import React, { useEffect, useRef } from 'react';
import { useDiscoveryContext } from '../context/DiscoveryContext';
import { useStreamingChat } from '../hooks/useStreamingChat';
import MessageBubble from './MessageBubble';
import TypingIndicator from './TypingIndicator';
import GreetingMessage from './GreetingMessage';
import StarterChips from './StarterChips';
import SuggestionChips from './SuggestionChips';

export default function MessageList() {
  const { state } = useDiscoveryContext();
  const { messages, status, suggestions } = state;
  const { sendMessage } = useStreamingChat(state.sessionId);
  const endRef = useRef(null);

  useEffect(() => {
    if (endRef.current && typeof endRef.current.scrollIntoView === 'function') {
      endRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
    }
  }, [messages.length, status, suggestions.length]);

  const hasUserMessages = messages.some((m) => m.role === 'user');
  const lastMessageIsAssistant =
    messages.length > 0 && messages[messages.length - 1].role === 'assistant';
  const showSuggestions =
    lastMessageIsAssistant &&
    status !== 'loading' &&
    Array.isArray(suggestions) &&
    suggestions.length > 0;

  const handleChipSelect = (text) => {
    sendMessage(text);
  };

  return (
    <div className="message-list" data-testid="message-list" role="log" aria-live="polite" aria-relevant="additions">
      <GreetingMessage />
      {!hasUserMessages && status !== 'loading' && (
        <StarterChips onSelect={handleChipSelect} />
      )}
      {messages.map((msg, idx) => (
        <MessageBubble
          key={msg.id || `${msg.role}-${idx}`}
          message={msg}
        />
      ))}
      {status === 'loading' && <TypingIndicator />}
      {showSuggestions && (
        <SuggestionChips
          suggestions={suggestions}
          onSelect={handleChipSelect}
        />
      )}
      <div ref={endRef} data-testid="message-list-end" />
    </div>
  );
}
